/** biome-ignore-all lint/nursery/useImageSize: Size is defined */
/** biome-ignore-all lint/performance/noImgElement: Can't use next/image */

import { useMemo } from "react";
import { useAppearance } from "@/hooks/use-appearance";
import { useTranslations } from "@/hooks/use-translations";
import { cn } from "@/lib/utils";

export function BankIdLogo({
  className = "",
  inverted = false,
}: {
  className?: string;
  inverted?: boolean;
}) {
  const { __ } = useTranslations();
  const { appearance, prefersDark } = useAppearance();

  const isDarkMode = useMemo(() => {
    if (appearance === "dark") {
      return true;
    }

    if (appearance === "light") {
      return false;
    }

    return prefersDark();
  }, [appearance, prefersDark]);

  const useBlackLogo = isDarkMode !== inverted;

  const fileName = useBlackLogo ? "logo-black.png" : "logo-white.png";

  return (
    <img
      alt={__("bank_id.logo_alt_text")}
      className={cn("h-8 w-8", className)}
      src={`/img/auth/bank-id/${fileName}`}
    />
  );
}
